import { createApp } from 'vue'
import TutorialVideo from '../components/ui/TutorialVideo.vue'

let mountedApps: { app: ReturnType<typeof createApp>; el: HTMLElement }[] = []

function mountAll() {
  document.querySelectorAll<HTMLElement>('[data-tutorial-video]').forEach((el) => {
    if (!el.isConnected) return
    if (el.dataset.tutorialVideoMounted === '1') return
    const data = el.dataset.tutorialVideo
    if (!data) return

    let video
    try { video = JSON.parse(data) } catch { return }
    if (!video) return

    try {
      const app = createApp(TutorialVideo, { video })
      app.mount(el)
      el.dataset.tutorialVideoMounted = '1'
      mountedApps.push({ app, el })
    } catch (e) {
      console.warn('TutorialVideo mount failed', e)
    }
  })
}

mountAll()
document.addEventListener('turbo:load', mountAll)
document.addEventListener('turbo:before-cache', () => {
  mountedApps.forEach(({ app, el }) => {
    try { app.unmount() } catch { /* ignore */ }
    delete el.dataset.tutorialVideoMounted
  })
  mountedApps = []
})
